export const isValidEmail = (email) => 
  /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

export const isValidAddress = (address) =>
  typeof address === "string" && address.trim().length >= 5;

export const isValidUSPhone = (phone) =>
  /^(\+1\s?)?(\([2-9]\d{2}\)|[2-9]\d{2})[-.\s]?\d{3}[-.\s]?\d{4}$/.test(
    phone.trim()
  );

export const isFormValid = (customerInfo) => {
  if (
    !customerInfo.firstName.trim() ||
    !customerInfo.lastName.trim() ||
    !isValidEmail(customerInfo.email) ||
    !isValidUSPhone(customerInfo.phone) ||
    !isValidAddress(customerInfo.shippingStreet) ||
    !customerInfo.shippingCity.trim() ||
    !customerInfo.shippingState.trim() ||
    !customerInfo.shippingPostal.trim() ||
    !customerInfo.shippingCountry.trim()
  ) {
    return false;
  }
  return true;
};

export const isBillingValid = (customerInfo, showBilling) =>
  !showBilling ||
  (isValidAddress(customerInfo.billingStreet) &&
    customerInfo.billingCity.trim() &&
    customerInfo.billingState.trim() &&
    customerInfo.billingPostal.trim() &&
    customerInfo.billingCountry.trim());